import { useState } from "react";
import "./Login.css";
import logo from "../assets/sofia_logo.webp";
import eosLogo from "../assets/eos_logo.png";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch("/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        onLogin(username); // pass username to App
      } else {
        setError(data.message || "Invalid username or password");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Failed to login. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={logo} alt="Sofia Logo" className="login-logo" />
        <h2>Welcome to Sofia</h2>

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="login-input"
          />
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in…" : "Log In"}
          </button>
        </form>
      </div>

      <div className="login-branding-bottom">
        <div className="logo-text-stack">
          <div className="logo-text">Sofia Agent AI</div>
          <div className="logo-subtext">
            powered by
            <img src={eosLogo} alt="EOS" className="powered-eos-logo" />
          </div>
        </div>

        <div className="right-brand" title="Kollecto Plus">
          <span className="right-brand-text">
            KOLLECTO <span className="right-brand-plus">PLUS</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Login;
